import {
	Button,
	InputAdornment, LinearProgress,
	makeStyles,
	SvgIcon, Table,
	TableBody,
	TableCell,
	TableContainer, TableHead,
	TablePagination,
	TableRow,
	TextField,
	Tooltip
} from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import React, { useEffect } from 'react';
import { Search as SearchIcon } from 'react-feather';
import Fuse from 'fuse.js'

import { useActions, useValues } from 'kea';

import { alertlogic } from 'src/store/alert';

const useStyles = makeStyles((theme) => ({
	root: {
		width: '100%',
		minWidth: 400,
		backgroundColor: theme.palette.background.paper,
		position: 'relative',
		overflow: 'auto',
		maxHeight: 400,
		paddingTop: '0px'
	},
	table: {
		minWidth: 800,
	},
	container: {
		minWidth: 400
	}
}));


let columns = [
	{
		field: "name",
		headerName: "Name",
		align: "left",
		width: 200,
	},
	{
		field: "actions",
		headerName: "Select",
		align: "left",
		width: 50,
	},
];


const withTooltip = (text, width) => (
	<Tooltip title={text}>
		<div style={{
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
			overflow: 'hidden',
			width: `${width}px`
		}}>
			{text}
		</div>
	</Tooltip >
)

const options = {
	includeScore: false,
	keys: [
		'name',
	]
}

const EditDialog = ({ exclude, handleAdd }) => {
	const classes = useStyles();
	const { alerts } = useValues(alertlogic);
	const { fetchAll: fetchAllAlert } = useActions(alertlogic);

	const [open, setOpen] = React.useState(false);
	const [checked, setChecked] = React.useState([]);
	const [page, setPage] = React.useState(0);
	const [rowsPerPage, setRowsPerPage] = React.useState(10);
	const [filtered, setFiltered] = React.useState(alerts);
	const [search, setSearch] = React.useState('');

	useEffect(() => {
		alerts ?? fetchAllAlert();
	}, []) // eslint-disable-line

	useEffect(() => {
		if (search === '') {
			setFiltered(alerts);
		} else {
			const fuse = new Fuse(alerts, options);
			let found = fuse.search(search).map(item => {
				return item.item;
			});
			setFiltered(found);
		}
	}, [alerts, search])

	const handleToggle = (value) => {
		const currentIndex = checked.indexOf(value);
		const newChecked = [...checked];

		if (currentIndex === -1) {
			newChecked.push(value);
		} else {
			newChecked.splice(currentIndex, 1);
		}

		setChecked(newChecked);
	};

	const handleClickOpen = () => {
		setOpen(true)
	}

	const handleClose = () => {
		setOpen(false)
	}

	const handleAddSelected = () => {
		setChecked([]);
		handleAdd(checked);
		setOpen(false)
	}


	const handleChangePage = (even, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (
		event
	) => {
		setRowsPerPage(+event.target.value);
		setPage(0);
	};


	const handle_search = (e) => setSearch(e.target.value);


	let excludedFiltered = [];
	if (filtered) {
		excludedFiltered = filtered.filter((item) => {
			for (const excluded_vehicle of exclude) {
				if (item._id === excluded_vehicle._id) {
					return false;
				}
			}
			return true;
		});
	}

	return (
		<div style={{ height: '100%', width: '100%', background: 'white' }} >
			<Button
				color="primary"
				variant="contained"
				aria-label="add"
				onClick={handleClickOpen}
			>
				Add
			</Button>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="form-dialog-title"
				maxWidth={'lg'}
			>
				<DialogTitle id="form-dialog-title">Add Alerts to this group</DialogTitle>
				<DialogContent>
					<div style={{ height: '100%', width: '100%', background: 'white' }}>
						<TableContainer className={classes.container}>
							<Table stickyHeader aria-label="sticky table" size='small'>
								<TableHead>
									<TableRow>
										<TableCell colSpan={columns.length} align={'left'}>
											<div className={classes.box}>
												<div className={classes.alignRight}>
													<TextField
														fullWidth
														size={'small'}
														InputProps={{
															startAdornment: (
																<InputAdornment position="start">
																	<SvgIcon
																		fontSize="small"
																		color="action"
																	>
																		<SearchIcon />
																	</SvgIcon>
																</InputAdornment>
															)
														}}
														onChange={handle_search}
														placeholder="Search..."
														variant="outlined"
													/>
												</div>
											</div>
										</TableCell>
									</TableRow>
									<TableRow>
										{columns.map((column) => (
											<TableCell
												key={column.field}
												align={column.align}
												style={{ minWidth: column.width }}
											>
												{column.headerName}
											</TableCell>
										))}
									</TableRow>
								</TableHead>
								<TableBody>
									{
										excludedFiltered && excludedFiltered.length > 0 ?
											excludedFiltered.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
												.map((row, index) => {
													// if(row.removed) return;
													return (
														<TableRow hover role="checkbox" tabIndex={-1} key={row._id}>
															{columns.map((column) => {
																const value = row[column.field];
																if (column.field === 'actions') {
																	return (
																		<>
																			<TableCell align={column.align}>
																				<Checkbox
																					edge="end"
																					onChange={(e) => handleToggle(row)}
																					checked={checked.find((item) => { return item._id === row._id }) || null}
																					inputProps={{ 'aria-labelledby': `checkbox-list-secondary-label-${index}` }}
																				/>
																			</TableCell>
																		</>
																	)
																}
																return (
																	<TableCell key={column.field} align={column.align}>
																		{column.format && typeof value === "number"
																			? column.format(value)
																			: withTooltip(value, column.width)}
																	</TableCell>
																);
															})}
														</TableRow>
													);
												})
											: <TableRow>
												<TableCell colSpan={columns.length} align={'center'}>
													Nothing left to add
												</TableCell>
											</TableRow>
									}
								</TableBody>
							</Table>
						</TableContainer>
						<TablePagination
							rowsPerPageOptions={[10]}
							component="div"
							count={excludedFiltered ? excludedFiltered.length : 0}
							rowsPerPage={rowsPerPage}
							page={page}
							onChangePage={handleChangePage}
							onChangeRowsPerPage={handleChangeRowsPerPage}
						/>
					</div>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} color="primary">
						Cancel
					</Button>
					<Button onClick={handleAddSelected} color="primary">
						Add
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	)
}


export default EditDialog
